import React from 'react'

import { cn } from '@/lib/utils'

import { Switch } from '../ui/switch'

import { Flex } from './Box'

const PrimarySwitch: React.FC<
  React.ComponentProps<typeof Switch> & { label?: React.ReactNode }
> = React.forwardRef(({ className, label, ...props }, ref) =>
  label ? (
    <Flex className="items-center space-x-2">
      <Switch
        ref={ref}
        className={cn(
          'rounded-sm data-[state=unchecked]:bg-border',
          '[&_span]:rounded-sm [&_span]:data-[state=checked]:bg-white [&_span]:data-[state=unchecked]:bg-white',
          className
        )}
        {...props}
      />
      {label}
    </Flex>
  ) : (
    <Switch ref={ref} className={cn('', className)} {...props} />
  )
)

export const RectSwitch: React.FC<
  React.ComponentProps<typeof Switch>
> = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <Switch
      ref={ref}
      className={cn(
        'rect-switch rounded-sm data-[state=unchecked]:bg-border',
        '[&_span]:rounded-sm [&_span]:data-[state=checked]:bg-white [&_span]:data-[state=unchecked]:bg-white',
        className
      )}
      {...props}
    />
  )
})

export default PrimarySwitch
